import React, {useEffect} from "react";
import './ManageDataPage.scss';
import type {Bag} from "../../services/classes/Bag";
import {useStores} from "../../stores";
import {Button, Grid, Typography} from "@mui/material";
import {DataSetSelectEditComponent} from "./DataSetSelectEditComponent";
import {generatePath, useLocation, useNavigate} from "react-router";
import {routes} from '../../routing/routes';
import {generateDashboardPath} from "../../routing/routing.utils";
import {observer} from "mobx-react-lite";
import {sitRoutes} from "../../sit/routing/sitRoutes";

export const ManageDataPage: React.FC = observer(() => {
    const {p, rootAppStore, bagStore, authStore} = useStores();


    if (!p.p.demoFakeDataIngestion) {
        //
        //
        console.warn('This page is for an older demo only!')
        //
        //
    }

    const navigate = useNavigate();
    const location = useLocation();
    useEffect(() => {
        bagStore.getAllBags();
    }, [bagStore])
    const bags = bagStore.userBagChoices;
    const fallBackDatabag = bagStore.userBagDefaultOption;

    const canEditName = authStore.canUpload

    const handleStart = () => {
        if (selectedBag && selectedBag.id !== -1) {
            bagStore.setBag(selectedBag);
            navigate(generateDashboardPath(location, {id: String(selectedBag.id)}, rootAppStore.app));
        }
    }

    const [selectedBag, setSelectedBag] = React.useState<Bag | undefined>(bagStore.bag);
    const [busy, setBusy] = React.useState(false);

    useEffect(() => {
        if (bags && bags.length > 0 && !selectedBag && fallBackDatabag) {
            setSelectedBag(fallBackDatabag)
        }
    }, [bags, selectedBag, fallBackDatabag])

    return (
        <section>
            <Grid container className="manage-data-page" justifyContent="center">
                <Grid size={3}/>
                <Grid>
                    <Typography variant="h4" component="h2" className="title">
                        Select data
                    </Typography>
                    <DataSetSelectEditComponent
                        enableEditName={canEditName}
                    bags={bags}
                    selectedBagId={selectedBag?.id}
                    disabled={busy}
                    onSelectBag={b => setSelectedBag(b)}
                    onPatchBag={b => {
                        // Note: b is a new object
                        if (!bags || busy) return;
                        const newBags = [...bags];
                        const patchI = bags.findIndex(b => b.id === selectedBag?.id);
                        if (patchI === -1) return;

                        newBags[patchI] = b;
                        setBusy(true);
                        bagStore.setAllBags(newBags)
                        bagStore.patch(b)
                            .then(r => setSelectedBag(r.data))
                            .finally(() => setBusy(false))
                    }}
                />
            </Grid>
            <Grid size={3}/>
                <Grid className="container-files" size={6}>
                    <section className="buttons">
                        <Button variant="contained" color="primary" className="bigger-button"
                                id="start-app-button"
                                onClick={handleStart} disabled={busy}>
                            Start
                        </Button>
                    </section>

                    {(p.p.demoFakeDataIngestion || p.p.enableDataIngestion) &&
                        <section className="buttons">
                            <Button variant="contained" color="primary" className="bigger-button"
                                    id="start-ingestion-app-button"
                                    onClick={() => {
                                        if (p.p.demoFakeDataIngestion) {
                                            navigate(generatePath(routes.data_upload));
                                        } else if (p.p.enableDataIngestion) {
                                            navigate(generatePath(routes.data_ingestion));
                                        }
                                    }}>
                                data ingestion
                            </Button>
                        </section>
                    }

                    {p.p.enableTaxonomyIngestion &&
                        <section className="buttons">
                            <Button variant="contained" color="primary" className="bigger-button"
                                    id="start-taxonomy-ingestion-app-button"
                                    onClick={() => {
                                        navigate(generatePath(routes.taxonomy_ingestion));
                                    }}>
                                taxonomy ingestion
                            </Button>
                        </section>
                    }

                    {p.p.enableSavingInitiativeTracker &&
                        <section className="buttons">
                            <Button variant="contained" color="primary" className="bigger-button"
                                    id="start-saving-initiative-tracker-app-button"
                                    onClick={() => {
                                        navigate(generatePath(sitRoutes.sit_initiatives));
                                    }}>
                                Initiative tracker
                            </Button>
                        </section>
                    }
                </Grid>
            </Grid>
        </section>
    );
});
